<template>
  <zm-drawer
    @ok="handleSubmit"
    :title="title"
    :width="drawerWidth"
    :visible="visible"
    size="large"
    @cancel="open(false)"
  >
    <div slot="drawerBody">
      <a-form :form="form">
        <div class="title">合同详情</div>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同名称" >
              <a-input
                placeholder="请输入合同名称"
                id="name"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['name', { rules: [{ required: true, message: '请输入合同名称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同编号" >
              <a-input
                placeholder="请输入合同编号"
                id="number"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['number', { rules: [{ required: true, message: '请输入合同编号！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目名称">
              <a-select
                :allowClear="true"
                placeholder="请选择项目名称"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit"
                v-decorator="['projectId', { rules: [{ required: true, message: '请选择项目名称！' }] }]"
              >
                <a-select-option
                  v-for="(option, index) in ProjectNameList"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="甲方名称">
              <a-select
                :allowClear="true"
                placeholder="请选择甲方名称"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit"
                v-decorator="['partyId', { rules: [{ required: true, message: '请选择甲方名称' }] }]"
              >
                <a-select-option
                  v-for="(option, index) in PartyNameList"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内容类型">
              <a-select
                :allowClear="true"
                placeholder="请选择内容类型"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit"
                v-decorator="['contentType', 
                  { 
                    rules: [{ required: true, message: '请选择内容类型！' }] 
                  }
                ]"
              >
                <a-select-option v-for="(option, index) in ContentTypeList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="签约日期">
              <a-date-picker
                :disabled="!isEdit"
                style="width: 100%"
                placeholder="请选择签约日期"
                v-decorator="['contractDate', { rules: [{ required: true, message: '请选择签约日期！' }] }]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护期限">
              <a-select
                :allowClear="true"
                placeholder="请选择维护期限"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit"
                v-decorator="['maintainDeadline', 
                  { 
                    rules: [{ required: true, message: '请选择质保期限！' }] 
                  }
                ]"
              >
                <a-select-option v-for="(option, index) in MaintainDeadlineList" :key="index" :value="option.code">
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="验收日期">
              <a-date-picker
                :disabled="!isEdit"
                style="width: 100%"
                placeholder="请选择验收日期"
                v-decorator="['checkDate', { rules: [{ required: true, message: '请选择验收日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办人">
              <a-select
                :allowClear="true"
                placeholder="请选择经办人"
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit"
                v-decorator="['operatorId', 
                  { 
                    initialValue:model.operatorId,
                    rules: [{ required: true, message: '请选择经办人！' }] 
                  }
                ]"
              >
                <a-select-option
                  v-for="(option, index) in OperatorNameList"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同金额" >
              <a-input
                placeholder="请输入合同金额"
                id="contractAmount"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['contractAmount', { rules: [{ required: true, message: '请输入合同金额！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider style="margin: 16px 0"></a-divider>
        <div class="title">产品信息</div>
        <!-- 此处循环 contractSaleProductList-->
          <product-modal
            ref="productModal"
            :form="form"
            :type="type"
            :arr="model.contractSaleProductList"
            :ProductNameList="ProductNameList"
          ></product-modal>
        <!-- 此处循环  contractSalePaymentList-->
        <a-divider style="margin: 16px 0"></a-divider>
        <div class="title">收款方式</div>
        <collection-modal
          ref="collectionModal"
          :form="form"
          :type="type"
          :arr="model.contractSalePaymentList"
          :PaymentTypeList="PaymentTypeList"
        ></collection-modal>
        <a-divider style="margin: 16px 0"></a-divider>
        <div class="title">附件上传</div>
        <a-row>
          <a-col :span="24" >
            <a-form-item
              label="合同附件"
              :labelCol="{ xs: { span: 24 },sm: { span: 2 } }" 
              :wrapperCol="{ xs: { span: 24 },sm: { span: 22 } }" 
            >
              <zm-upload
                v-if="isShow"
                ref="uploader"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="fileList"
                acceptType="pdf"
                @handleUpload="handleUpload"
                v-decorator="['uploader', { rules: [{ required: true, message: '请上传文件或等待上传成功！' }] }]"
              ></zm-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>

<script>
import moment from 'moment'
import productModal from './loopModal/productModal'
import collectionModal from './loopModal/collectionModal'
import { mapState } from 'vuex'
import { getProjectList } from '@/api/project'
import { getProprietorsList } from '@/api/proprietors'
import { getDictInfoByCode } from '@/api/dict'
import { getUserBaseInfo } from '@/api/baseInfo'
import { getProductList } from '@/api/product'
import { insertSale } from '@/api/sale'
export default {
  name: 'editPurchases',
  mounted() {
    console.log('edit_sale_run')
    this.getSelectProjectNameList()
    this.getSelectPartyNameList()
    this.getSelectContentTypeList()
    this.getSelectMaintainDeadlineList()
    this.getSelectOperatorNameList()
    this.getSelectProductNameList()
    this.getSelectPaymentTypeList()
  },
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth() {
      const width = window.innerWidth - 200
      return width
    },
    ...mapState({}),
  },
  components: {
    productModal,
    collectionModal
  },
  data() {
    return {
      ProjectNameList: [],
      PartyNameList: [],
      ContentTypeList: [],
      MaintainDeadlineList: [],
      OperatorNameList: [],
      ProductNameList: [],
      PaymentTypeList: [],
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'purchases' }),
      visible: false,
      defaultModel: {},
      model: {},
      modelListId: NaN,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      colSpan: 6,
      headers: {
        Authorization: this.$store.state.user.token
      },
      fileList: [],
      isProductNameChange:false,
      isShow:true
    }
  },
  methods: {
    // 设置类型
    setType(type) {
      this.type = type
    },
    // 设置标题
    setTitle(title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel(model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      //退出时保持附件组件的销毁，保证form封装字段upload的值正常校验
      this.isShow = flag
      this.visible = flag
      console.log(this.model)
      if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
        if (flag) {
          this.$nextTick(() => {
            console.log('form值:',this.form.getFieldsValue());
            this.form.setFieldsValue({
              name: this.model.name,
              number: this.model.number,
              projectId: this.model.projectId,
              partyId:this.model.partyId,
              operatorId:this.model.operatorId,
              contentType:this.model.contentType,
              maintainDeadline:this.model.maintainDeadline,
              checkDate: moment(this.model.checkDate),
              contractAmount: this.model.contractAmount,
              partyName: this.model.partyName,
              contractDate: moment(this.model.contractDate)
            })
            console.log('fileList:',this.model.contractSaleFileList);
            this.fileList = this.model.contractSaleFileList
          })

          // this.getModelInfo(this.model) 通过接口获取详情
        }
      } else {
        this.formClear()
      }
      // 初始化loop组件(动画结束后调用，不然丑)
      setTimeout(() => {
        this.$refs.productModal.init()
        this.$refs.collectionModal.init()
      }, 200);
    },
    // 提交表单
    handleSubmit() {
      //没上传或还在上传，则不给字段赋值，则会通知校验
      if(this.fileList.length != 0){
        this.form.setFieldsValue({
          uploader:"随便给个值"
        })
      }
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          //产品信息数据arr
          const contractSaleProductList = this.$refs.productModal.getProductList()
          console.log('contractSaleProductList', contractSaleProductList)

          //收款方式数据arr
          const contractSalePaymentList = this.$refs.collectionModal.getData()
          console.log('contractSalePaymentList',contractSalePaymentList);

          let formModel = {
            contractSalePaymentList,
            contractSaleProductList,
            name:value.name,
            number:value.number,
            partyId:value.partyId,
            partyName:this.PartyNameList.filter((val)=>{return val.id === value.partyId})[0].name,
            projectId:value.projectId,
            projectName:this.ProjectNameList.filter(val=>val.id === value.projectId)[0].name,
            checkDate:moment(value.checkDate).format('YYYY-MM-DD'),
            contractDate:moment(value.contractDate).format('YYYY-MM-DD'),
            operatorId:value.operatorId,
            operatorName:this.OperatorNameList.filter((val)=>{return val.id === value.operatorId})[0].userName,
            contentType:value.contentType,
            contractAmount:value.contractAmount,
            maintainDeadline:value.maintainDeadline,
            contractSaleFileList:this.fileList
          }
          
          console.log();
          console.log("处理过的！！！",formModel);



          const params = { id:this.model.id, ...formModel }
          console.log("处理过的！！！",params);

          if (this.type === this.$sysInfo.MODAL_ADD) {
            delete params.id
            
            const res = await insertSale(params).catch((error) => {
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            const res = await insertSale(params).catch((error) => {
              console.log('更新失败', error)
              this.$message.error('更新失败，请稍后重试！')
            })
            if (res && res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.warning(res.info.message)
            }
          }
        }
      })
    },
    // 获取当前的model详情

    handleChange() {},
    // 清空表单
    formClear() {
      this.$nextTick(() => {
        this.model = {}
        this.form.resetFields()
      })
      this.$refs.uploader.clearFileList()
      this.fileList = []
    },
    cancel() {
      this.formClear()
      this.open(false)
    },
    // 获取select列表
    getSelectProjectNameList() {
      getProjectList({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.ProjectNameList = res.data
        }
      })
    },
    getSelectPartyNameList() {
      getProprietorsList({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.PartyNameList = res.data
        }
      })
    },
    getSelectContentTypeList() {
      getDictInfoByCode({ pCode: 'CONTRACT_CONTENT_TYPE' }).then((res) => {
        if (res.status === 0) {
          this.ContentTypeList = res.data
        }
      })
    },
    getSelectMaintainDeadlineList() {
      getDictInfoByCode({ pCode: 'MAINTAIN_DEADLINE' }).then((res) => {
        if (res.status === 0) {
          this.MaintainDeadlineList = res.data
        }
      })
    },
    getSelectOperatorNameList() {
      getUserBaseInfo({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.OperatorNameList = res.data
        }
      })
    },
    getSelectProductNameList() {
      getProductList({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.ProductNameList = res.data
        }
      })
    },
    getSelectPaymentTypeList() {
      getDictInfoByCode({ pCode: 'PAYMENT_TYPE' }).then((res) => {
        if (res.status === 0) {
          this.PaymentTypeList = res.data
        }
      })
    },
    //文件列表获取
   handleUpload(fileList) {
      this.fileList = fileList
    },
    //Select关联字段
    changeProjectName(value){
      this.form.setFieldsValue({
        projectName:value.label
      })
    },
    changePartyName(value){
      this.form.setFieldsValue({
        partyName:value.label
      })
    },
    changeOperatorName(value){
      this.form.setFieldsValue({
        operatorName:value.label
      })
    },
    //判断select是否编辑过
    changeProductName(bool){
      this.isProductNameChange = bool
    }
  },
}
</script>

<style scoped lang="less">
.title {
  font-weight: bold;
  margin-bottom: 10px;
}
.title::before {
  display: inline-block;
  width: 4px;
  height: 12px;
  background: #1791ff;
  content: '';
  margin-right: 7px;
}
</style>

